import React from 'react';
import {FormattedMessage} from 'react-intl';

import {isTeacherMode} from '../../hetao-mode';

import penIconURL from './pen/pen.png';
import penInsetIconURL from './pen/pen-small.svg';

import videoImage from './video-sensing.png';
import microbitImage from './microbit.png';
import ev3Image from './ev3.png';
import wedoImage from './wedo.png';
import translateIconURL from './translate/translate.png';
import translateInsetIconURL from './translate/translate-small.png';
import musicIconURL from './music/music.png';
import musicInsetIconURL from './music/music-small.svg';
import microbitPeripheralImage from './peripheral-connection/microbit/microbit-illustration.svg';
import microbitMenuImage from './peripheral-connection/microbit/microbit-small.svg';
import ev3PeripheralImage from './peripheral-connection/ev3/ev3-hub-illustration.svg';
import ev3MenuImage from './peripheral-connection/ev3/ev3-small.svg';
import wedoPeripheralImage from './peripheral-connection/wedo/wedo-illustration.svg';
import wedoMenuImage from './peripheral-connection/wedo/wedo-small.svg';
import wedoButtonImage from './peripheral-connection/wedo/wedo-button-illustration.svg';
import text2speechIconURL from './text2speech/text2speech.png';
import text2speechInsetIconURL from './text2speech/text2speech-small.svg';
import speech2textIconURL from './speech2text/speech2text.svg';
import speech2textInsetIconURL from './speech2text/speech2text-small.svg';
import magicBlockIconUrl from './magic-block/magic-block.svg';
import magicBlockInsetIconUrl from './magic-block/magic-block-small.svg';
import doodleSenseIconURL from './doodle-sense/doodle-sense.svg';
import doodleSenseInsetIconURL from './doodle-sense/doodle-sense-small.svg';
import txt2imgIconURL from './txt2img/txt2img.jpg';
import txt2imgInsetIconURL from './txt2img/txt2img-small.svg';
import aichatIconURL from './aichat/aichat.png';
import aichatInsetIconURL from './aichat/aichat-small.svg';
import ailabIconURL from './ailab/ailab.svg';
import ailabInsetIconURL from './ailab/ailab-small.svg';


export default [
    {
        name: (
            <FormattedMessage
                defaultMessage="Music"
                description="Name for the 'Music' extension"
                id="gui.extension.music.name"
            />
        ),
        extensionId: 'music',
        iconURL: musicIconURL,
        insetIconURL: musicInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Play instruments and drums."
                description="Description for the 'Music' extension"
                id="gui.extension.music.description"
            />
        ),
        featured: true,
        show: true
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Pen"
                description="Name for the 'Pen' extension"
                id="gui.extension.pen.name"
            />
        ),
        extensionId: 'pen',
        iconURL: penIconURL,
        insetIconURL: penInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Draw with your sprites."
                description="Description for the 'Pen' extension"
                id="gui.extension.pen.description"
            />
        ),
        featured: true,
        show: true
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Video Sensing"
                description="Name for the 'Video Sensing' extension"
                id="gui.extension.videosensing.name"
            />
        ),
        extensionId: 'videoSensing',
        iconURL: videoImage,
        description: (
            <FormattedMessage
                defaultMessage="Sense motion with the camera."
                description="Description for the 'Video Sensing' extension"
                id="gui.extension.videosensing.description"
            />
        ),
        featured: true,
        show: false
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="文字朗读"
                description="Name for the Text to Speech extension"
                id="gui.extension.text2speech.name"
            />
        ),
        extensionId: 'text2speech',
        collaborator: 'Amazon Web Services',
        iconURL: text2speechIconURL,
        insetIconURL: text2speechInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="让你的作品开口说话"
                description="Description for the Text to speech extension"
                id="gui.extension.text2speech.description"
            />
        ),
        featured: true,
        show: true,
        internetConnectionRequired: true
    },

    {
        name: (
            <FormattedMessage
                defaultMessage="语音识别"
                description="Name for the '语音识别' extension"
                id="gui.extension.speech2text.name"
            />
        ),
        extensionId: 'speech2text',
        iconURL: speech2textIconURL,
        insetIconURL: speech2textInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="
                语音识别"
                description="Description for the 'speech2text' extension"
                id="gui.extension.speech2text.description"
            />
        ),
        featured: true,
        show: true
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="翻译"
                description="Name for the Translate extension"
                id="gui.extension.translate.name"
            />
        ),
        extensionId: 'translate',
        iconURL: translateIconURL,
        insetIconURL: translateInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="把文字翻译成多种语言"
                description="Description for the Translate extension"
                id="gui.extension.translate.description"
            />
        ),
        featured: true,
        show: true,
        internetConnectionRequired: true

    },
    {
        name: (
            <FormattedMessage
                defaultMessage="涂鸦识别"
                description="Name for the '涂鸦识别' extension"
                id="gui.extension.doodleSense.name"
            />
        ),
        extensionId: 'doodleSense',
        iconURL: doodleSenseIconURL,
        insetIconURL: doodleSenseInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="
                涂鸦识别"
                description="Description for the 'doodleSense' extension"
                id="gui.extension.doodleSense.description"
            />
        ),
        featured: true,
        show: true
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="生成图片"
                description="Name for the '生成图片' extension"
                id="gui.extension.txt2img.name"
            />
        ),
        extensionId: 'txt2img',
        iconURL: txt2imgIconURL,
        insetIconURL: txt2imgInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="
                生成图片"
                description="Description for the 'txt2img' extension"
                id="gui.extension.txt2img.description"
            />
        ),
        featured: true,
        show: true
    },
    
    {
        name: 'micro:bit',
        extensionId: 'microbit',
        iconURL: microbitImage,
        description: (
            <FormattedMessage
                defaultMessage="Connect your projects with the world."
                description="Description for the 'micro:bit' extension"
                id="gui.extension.microbit.description"
            />
        ),
        featured: true,
        show: false,
        disabled: false,
        launchPeripheralConnectionFlow: true,
        useAutoScan: false,
        peripheralImage: microbitPeripheralImage,
        smallPeripheralImage: microbitMenuImage,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their micro:bit."
                id="gui.extension.microbit.connectingMessage"
            />
        ),
        helpLink: 'https://scratch.mit.edu/microbit'
    },
    {
        name: 'LEGO MINDSTORMS EV3',
        extensionId: 'ev3',
        iconURL: ev3Image,
        description: (
            <FormattedMessage
                defaultMessage="Build interactive robots and more."
                description="Description for the 'LEGO MINDSTORMS EV3' extension"
                id="gui.extension.ev3.description"
            />
        ),
        featured: true,
        show: false,
        disabled: false,
        launchPeripheralConnectionFlow: true,
        useAutoScan: false,
        peripheralImage: ev3PeripheralImage,
        smallPeripheralImage: ev3MenuImage,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting. Make sure the pin on your EV3 is set to 1234."
                description="Message to help people connect to their EV3. Must note the PIN should be 1234."
                id="gui.extension.ev3.connectingMessage"
            />
        ),
        helpLink: 'https://scratch.mit.edu/ev3'
    },
    {
        name: 'LEGO WeDo 2.0',
        extensionId: 'wedo2',
        iconURL: wedoImage,
        description: (
            <FormattedMessage
                defaultMessage="Build with motors and sensors."
                description="Description for the 'LEGO WeDo 2.0' extension"
                id="gui.extension.wedo2.description"
            />
        ),
        featured: true,
        show: false,
        disabled: false,
        launchPeripheralConnectionFlow: true,
        useAutoScan: true,
        peripheralImage: wedoPeripheralImage,
        smallPeripheralImage: wedoMenuImage,
        peripheralButtonImage: wedoButtonImage,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their WeDo."
                id="gui.extension.wedo2.connectingMessage"
            />
        ),
        helpLink: 'https://scratch.mit.edu/wedo'

    },
    {
        name: (
            <FormattedMessage
                defaultMessage="魔法块"
                description="Name for the 'magicblocks' extension"
                id="gui.extension.magicblocks.name"
            />
        ),
        extensionId: 'magicblocks',
        iconURL: magicBlockIconUrl,
        insetIconURL: magicBlockInsetIconUrl,

        description: (
            <FormattedMessage
                defaultMessage="上课流程的处理"
                description="for the 'magicblocks' extension"
                id="gui.extension.magicblocks.description"
            />
        ),
        featured: true,
        show: isTeacherMode()
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="自然对话"
                description="Name for the 'aichat' extension"
                id="gui.extension.aichat.name"
            />
        ),
        extensionId: 'aichat',
        iconURL: aichatIconURL,
        insetIconURL: aichatInsetIconURL,

        description: (
            <FormattedMessage
                defaultMessage="自然对话"
                description="description for the 'aichat' extension"
                id="gui.extension.aichat.description"
            />
        ),
        featured: true,
        show: true
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="AI实验室"
                description="Name for the 'ailab' extension"
                id="gui.extension.ailab.name"
            />
        ),
        extensionId: 'ailab',
        iconURL: ailabIconURL,
        insetIconURL: ailabInsetIconURL,

        description: (
            <FormattedMessage
                defaultMessage="体验多种强大的A服务工具"
                description="description for the 'ailab' extension"
                id="gui.extension.ailab.description"
            />
        ),
        featured: true,
        show: true
    }
];
